import React from 'react';
import { Card } from './ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { Badge } from './ui/badge';
import { faqItems } from '../mockData';

const FAQ = () => {
  return (
    <section id="faq" className="py-20 bg-gradient-to-b from-gray-50 to-white scroll-mt-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-green-100 text-green-700 hover:bg-green-100">
            Foire aux questions
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Questions fréquentes
          </h2>
          <p className="text-xl text-gray-600">
            Tout ce que vous devez savoir sur la location de benne
          </p>
        </div>

        <Card className="p-8 shadow-lg border-0">
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, index) => (
              <AccordionItem key={item.id} value={`item-${item.id}`}>
                <AccordionTrigger className="text-left hover:text-green-600 transition-colors">
                  <span className="font-semibold text-gray-900">{item.question}</span>
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Card>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Vous avez d'autres questions ?
          </p>
          <a
            href="tel:0745558835"
            className="inline-flex items-center text-green-600 hover:text-green-700 font-semibold text-lg"
          >
            Contactez-nous au 07 45 55 88 35
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;